import { Form } from 'formik';
import styled from 'styled-components';

export const StyledForm = styled(Form)`
  margin-top: 2vh;
  @media (max-width: 768px) {
    padding: 1em 1em;
  }`;

export const RequiredFieldsNoticeText = styled.p`
  margin: 0 0 0.75rem 0;
`;

export const ScreenReaderOnly = styled.span`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;
